import { palette } from '../../theme/palette';
import { RadioButtonVariant } from '../../types/radio';
import { BodyGrey, BodyLarge } from '../Typography';
import { Box, Radio, styled } from '@mui/material';

export const Root = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'checked' && prop !== 'variant',
})<{
  checked?: boolean;
  variant?: RadioButtonVariant;
}>`
  border-radius: 5px;
  cursor: pointer;
  position: relative;
  height: fit-content;

  ${(prop) =>
    prop.variant === RadioButtonVariant.DEFAULT
      ? {
          border: `1px solid ${prop.checked ? '#f16622' : '#A9A9A9'}`,
          backgroundColor: prop.checked ? 'rgba(241, 103, 34, 0.08)' : 'none',
          padding: '8px 24px',
          minHeight: '90px',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          gap: '5px',
        }
      : {
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          minHeight: '30px',
        }}
`;

export const TitleContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{
  variant?: RadioButtonVariant;
}>`
  text-transform: capitalize;
  line-height: 20px;
`;

export const Title = styled(BodyLarge, {
  shouldForwardProp: (prop) => prop !== 'radioVariant',
})<{
  radioVariant?: RadioButtonVariant;
}>`
  margin-bottom: 0px;
  line-height: 20px;
  @media (max-width: 767px) {
    font-size: 16px;
  }

  ${(prop) =>
    prop.radioVariant === RadioButtonVariant.COMPACT && {
      color: palette.collection.grey.d575,
    }};
`;

export const Description = styled(BodyGrey, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{
  variant?: RadioButtonVariant;
}>`
  margin-bottom: 0px;
  line-height: 18px;
`;

export const StyledRadio = styled(Radio, {
  shouldForwardProp: (prop) => prop !== 'variant',
})<{
  variant?: RadioButtonVariant;
}>`
  border-radius: 50%;
  box-sizing: border-box;
  height: 18px;
  width: 18px;
  ${(prop) =>
    prop.variant === RadioButtonVariant.COMPACT
      ? {
          position: 'relative',
        }
      : {
          position: 'absolute',
          top: '12px',
          right: '12px',
        }};
`;
